import { cn } from "@zaphub/ui";

/** Marca: um "Z" de fio de sinal terminando num nó. */
export function Logo({ className, mostrarNome = true }: { className?: string; mostrarNome?: boolean }) {
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      <svg viewBox="0 0 32 32" className="size-7" aria-hidden="true">
        <rect width="32" height="32" rx="7" className="fill-foreground" />
        <path
          d="M8 22V10l16 12V10"
          fill="none"
          className="stroke-background"
          strokeWidth="2.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="24" cy="10" r="2.4" className="fill-primary" />
      </svg>
      {mostrarNome && <span className="font-display text-lg font-semibold tracking-tight">ZapHub</span>}
    </span>
  );
}
